// Lib
import { put, takeEvery } from 'redux-saga/effects';

// Actions
import { GetSubscriptionsStatus, SetSubscriptionsStatus } from '@actions/user';

//Queries
import { getUserPaymentStatus } from '@graphql/queries/data';

// Api
import client from '@api';
import { ErrorCategory, handleError } from '@services/errorService';

// Types
interface Subscription {
  _id: string;
  status: string;
  [key: string]: unknown;
}

interface SubscriptionsResponse {
  data: {
    me: {
      subscriptions: Subscription[];
    };
  };
}

function* GetSubscriptionsInfo(): Generator<unknown, void, unknown> {
  try {
    const response = (yield client().query({
      query: getUserPaymentStatus,
    })) as SubscriptionsResponse;

    const subscriptions = response.data.me.subscriptions;
    yield put(SetSubscriptionsStatus(subscriptions));
  } catch (e) {
    handleError(e, { category: ErrorCategory.GRAPHQL, silent: true });
  }
}

function* paymentsSaga(): Generator<unknown, void, unknown> {
  yield takeEvery(GetSubscriptionsStatus, GetSubscriptionsInfo);
}

export default paymentsSaga;
